import { QueryClient } from "@tanstack/react-query";

/**
 * Configuration globale de React Query
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache pendant 5 minutes par défaut
      staleTime: 5 * 60 * 1000,
      
      // Garde les données en cache pendant 10 minutes
      gcTime: 10 * 60 * 1000,
      
      // Retry 1 fois en cas d'erreur
      retry: 1,
      
      // Ne pas refetch automatiquement au focus de la fenêtre
      refetchOnWindowFocus: false,
      
      // Refetch si les données sont stale et que le composant remonte
      refetchOnMount: true,
      
      // Ne pas refetch lors de la reconnexion réseau (sauf si stale)
      refetchOnReconnect: false,
    },
    mutations: {
      // Retry 0 fois pour les mutations (éviter les duplications)
      retry: 0,
    },
  },
});

/**
 * Query Keys centralisées
 * Permet d'invalider facilement les caches
 */
export const queryKeys = {
  // Orders
  orders: ["orders"] as const,
  order: (id: string) => ["orders", id] as const,
  
  // Baskets
  baskets: ["baskets"] as const,
  basket: (id: string) => ["baskets", id] as const,
  fournisseurBaskets: (fournisseurId: string) => ["baskets", "fournisseur", fournisseurId] as const,
  
  // Products
  products: ["products"] as const,
  product: (id: string) => ["products", id] as const,
  storeProducts: (storeId: string) => ["products", "store", storeId] as const,
  
  // Categories
  categories: ["categories"] as const,
  category: (id: string) => ["categories", id] as const,
  
  // Users
  users: ["users"] as const,
  user: (id: string) => ["users", id] as const,
  
  // Stores
  stores: ["stores"] as const,
  store: (id: string) => ["stores", id] as const,
  
  // Fournisseurs
  fournisseurs: ["fournisseurs"] as const,
  fournisseur: (id: string) => ["fournisseurs", id] as const,
  
  // Stats
  stats: (fournisseurId: string) => ["stats", fournisseurId] as const,
  adminStats: ["stats", "admin"] as const,
};
